import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/* eslint-disable react/prop-types */
const HeroCarousel = ({ events }) => {
    const baseSlides = events.map((e) => {
        const eventUrl = e.eventUrl || `/eventos/${e.slug}`;
        return {
            id: e.uniqueId || e.id,
            img: e.img,
            nombre: e.nombre,
            eventUrl,
            isExternalEvent: /^https?:\/\//.test(eventUrl),
        };
    });
    if (baseSlides.length === 0) return null;

    const MIN_LOOP_SLIDES = 6;
    const slides =
        baseSlides.length >= MIN_LOOP_SLIDES
            ? baseSlides
            : Array.from({ length: MIN_LOOP_SLIDES }, (_, index) => ({
                  ...baseSlides[index % baseSlides.length],
                  loopKey: `${baseSlides[index % baseSlides.length].id}-${index}`,
              }));

    return (
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            centeredSlides
            grabCursor
            slideToClickedSlide
            breakpoints={{
                0: { slidesPerView: 1.2, spaceBetween: 2 },
                480: { slidesPerView: 1.5, spaceBetween: 0 },
                640: { slidesPerView: 1.7, spaceBetween: 0 },
                1024: { slidesPerView: 2, spaceBetween: 0 },
                1280: { slidesPerView: 3, spaceBetween: 0 },
            }}
            loop
            className="hero-swiper h-[78vh] min-h-[460px] w-full overflow-hidden [--swiper-navigation-color:rgb(253_191_4)] [--swiper-pagination-color:rgb(253_191_4)] [--swiper-pagination-bullet-inactive-color:rgb(161_161_170)] [--swiper-navigation-size:30px]"
        >
            {slides.map((slide) => (
                <SwiperSlide key={slide.loopKey || slide.id} className="hero-slide !h-full">
                    {slide.isExternalEvent ? (
                        <a href={slide.eventUrl} className="hero-slide-link group">
                            <img
                                src={slide.img}
                                loading="lazy"
                                alt={slide.nombre || "Evento"}
                                className="hero-slide-image"
                            />
                        </a>
                    ) : (
                        <Link to={slide.eventUrl} className="hero-slide-link group">
                            <img
                                src={slide.img}
                                loading="lazy"
                                alt={slide.nombre || "Evento"}
                                className="hero-slide-image"
                            />
                        </Link>
                    )}
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default HeroCarousel;
